import './bootstrap.js'
import {createPinia} from 'pinia';
import {createSSRApp, h} from 'vue';
import {createInertiaApp, router} from '@inertiajs/vue3';
import.meta.glob(['../images/**']);
import {InertiaProgress} from '@inertiajs/progress'
import Layout from "@/js/Shared/Layout.vue"
// import 'flowbite';

createInertiaApp({
    resolve: (name) => {
        const pages = import.meta.glob('./Pages/**/*.vue', {eager: true});
        let page = pages[`./Pages/${name}.vue`];
        page.default.layout = page.default.layout || Layout
        return page
    },
    setup({el, App, props, plugin}) {
        createSSRApp({render: () => h(App, props)})
            .use(plugin)
            .mixin({methods: {route: window.route}})
            .use(createPinia())
            .mount(el);
    },
    progress: {
        // delay: 250,
        color: '#ff9a00',
        includeCSS: true,
    },
});

InertiaProgress.init()

// === Яндекс.Метрика: хиты при SPA-навигации Inertia ===
router.on('success', () => {
    if (typeof window !== 'undefined' && typeof ym === 'function') {
        try {
            // фиксируем переход внутри SPA
            ym(100283064, 'hit', window.location.pathname + window.location.search, {
                title: document.title,
                // можно добавить referer вручную, но Метрика обычно сама его видит
            })
        } catch (e) {
            console.warn('YM hit error:', e)
        }
    }
})
